import collectionsConfig from '~~/configs/collections.config';

export default async function useCollection(
  collectionName: string,
): Promise<Array<unknown> | undefined> {
  const { objectKeysToCamelCase } = formatUtils();
  const cms = useCms();

  // Check cache for the requested singleton
  const cacheKey = collectionName;
  const cachedItem = useNuxtData(cacheKey).data.value;
  let item = cachedItem ? objectKeysToCamelCase(cachedItem) : undefined;

  if (!item) {
    const fields = collectionsConfig[collectionName as keyof typeof collectionsConfig];

    // Fetch data from Directus and format it
    const { data, error } = await useAsyncData(cacheKey, () =>
      cms.readItems(collectionName, { fields }),
    );

    if (error.value) {
      throw error.value;
    }

    item = data.value ? objectKeysToCamelCase(data.value) : undefined;
  }

  return item;
}
